import React from 'react';
import {MobileDialog} from '../dialog/Dialog';
import 'simplebar/dist/simplebar.min.css';
import '../../simplebar.css'
import {CouponsPanel} from "./CouponsPanel";
import { useDispatch, useSelector } from 'react-redux';
import {StoreType} from "../../store/spirs/types";
import { rightPanelTabType } from '../../store/spirs/reducers/rightPanelReducer';
import { CHANGE_RIGHT_PANEL_TAB, MOBILE_MODAL_COUPON } from '../../store/spirs/actions';

export const MobileCoupons: React.FC<{ type: rightPanelTabType }> = ({type}) => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(CHANGE_RIGHT_PANEL_TAB(type));
    }, [type])
    return (
        <div className="pb-[10px] min-w-[320px] bg-[#171A1E] desktop:min-w-[430px]">
            <div className="relative top-[10px] min-w-[320px] mx-auto desktop:min-w-[430px] bg-[#171A1E] tablet::w-full">
                <CouponsPanel/>
            </div>
        </div>
    );
};

export const MobileCouponsModal: React.FC = () => {
    const isOpen = useSelector((state: StoreType) => state.mobileCouponModal);
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(MOBILE_MODAL_COUPON(false));
    }

    return (<MobileDialog
        aria-labelledby="coupons"
        isOpen={isOpen}
        onClose={onClose}>
        <div>
            <MobileCoupons type={"coupon"}/>
        </div>
    </MobileDialog>)
};
